import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "katex/dist/katex.min.css";
import "./styles.css";
import "./portal.css";
import { App } from "./App";
import { PageErrorBoundary } from "./PageErrorBoundary";
import "./theme.css";

createRoot(document.getElementById("root")!).render(<StrictMode><PageErrorBoundary><App /></PageErrorBoundary></StrictMode>);
